import React from 'react'
import PropTypes from 'prop-types'

import chipRemove from 'resources/invoice_event_remove_icon.png'

const EventItem = ({ style, referencedEvent, onRemoveClicked }) => {
  return (
    <div style={{ ...styles.event, ...style }}>
      <div style={styles.eventInfo}>
        <div style={styles.eventName}>{ referencedEvent.name }</div>
        <div style={styles.eventDate}>
          {
            referencedEvent.startDate
              ? `${referencedEvent.startDate} - ${referencedEvent.endDate}`
              : `${referencedEvent.endDate}`
          }
        </div>
      </div>
      <img
        title='Remove'
        width={16}
        height={16}
        src={chipRemove}
        style={{ cursor: 'pointer' }}
        onClick={onRemoveClicked}/>
    </div>
  )
}

EventItem.propTypes = {
  style: PropTypes.object.isRequired,
  referencedEvent: PropTypes.object.isRequired,
  onRemoveClicked: PropTypes.func.isRequired
}

export default class ReferencedEventsList extends React.Component {

  static propTypes = {
    style: PropTypes.object.isRequired,
    invoiceEditor: PropTypes.object.isRequired,
    onEventRemoveRequested: PropTypes.func.isRequired
  }

  render() {
    const events = this.props.invoiceEditor.getReferencedEvents()
    if (!events || !events.length) {
      return null
    }
    return (
      <div style={{ ...styles.container, ...this.props.style }}>
        { events.map((referencedEvent, index) =>
          <EventItem
            key={index}
            referencedEvent={referencedEvent}
            style={{ marginRight: 8, marginBottom: 8 }}
            onRemoveClicked={() => this.props.onEventRemoveRequested(referencedEvent)} />)
        }
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  event: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: 'solid 1px #9b9b9b',
    borderRadius: 18,
    width: 200,
    height: 28,
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: 2,
    paddingBottom: 2
  },
  eventInfo: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    width: '95%'
  },
  eventName: {
    color: '#4a4a4a',
    fontSize: 14,
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  eventDate: {
    color: '#9b9b9b',
    fontSize: 10
  }
}



// WEBPACK FOOTER //
// ./src/billing/invoices/modules/header/ReferencedEventsList.js